
import { defineComponent, computed, WritableComputedRef } from "vue"
export default defineComponent({
  name:'demo_label_config_panel',
  props: {
    type: {
      type: String,
      default: "circle",
    },
    radius: {
      type: Number,
      default: 16,
    },
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    borderRadius: {
      type: Number,
      default: 4,
    },
    strokeWidth: {
      type: Number,
      default: 4,
    },
    strokeColor: {
      type: String,
      default: "#000000",
    },
    strokeDasharray: {
      type: String,
      default: "none",
    },
    color: {
      type: String,
      default: "#000000",
    },
  },
  emits: [
    "update:type",
    "update:radius",
    "update:width",
    "update:height",
    "update:borderRadius",
    "update:strokeWidth",
    "update:strokeColor",
    "update:strokeDasharray",
    "update:color",
  ],
  setup(props, { emit }) {
    const vars: { [name: string]: WritableComputedRef<any> } = {}
    const keys = Object.keys(props) as (keyof typeof props)[]
    for (const key of keys) {
      vars[key] = computed({
        get: () => props[key],
        set: v => emit(`update:${key}` as any, v),
      })
    }
    return vars
  },
})
